"use client";

import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import { ArrowLeft } from "lucide-react";
import { useTranslation } from "react-i18next";
import { LandingHeader } from "@/widgets/landing/ui/landing-header";
import { AccountDeletionFlow } from "../account-deletion/_components/account-deletion-flow";
export function AccountDeletionPageClient(t0) {
  const $ = _c(20);
  const {
    homeHref: t1
  } = t0;
  const homeHref = t1 === undefined ? "/" : t1;
  const {
    t
  } = useTranslation();
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <LandingHeader />;
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <ArrowLeft className="size-4" />;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== t) {
    t4 = t("landing.accountDeletion.backHome");
    $[2] = t;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== homeHref || $[5] !== t4) {
    t5 = <Link href={homeHref} className="inline-flex items-center gap-1.5 text-sm font-medium text-teal-600 transition-colors hover:text-teal-700">{t3}{t4}</Link>;
    $[4] = homeHref;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t) {
    t6 = t("landing.accountDeletion.title");
    $[7] = t;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t6) {
    t7 = <h1 className="mt-6 text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl">{t6}</h1>;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== t) {
    t8 = t("landing.accountDeletion.intro");
    $[11] = t;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== t8) {
    t9 = <p className="mt-4 text-base leading-relaxed text-slate-600">{t8}</p>;
    $[13] = t8;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <AccountDeletionFlow />;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== t5 || $[17] !== t7 || $[18] !== t9) {
    t11 = <div className="relative min-h-screen scroll-smooth bg-white text-slate-900 antialiased">{t2}<main className="px-6 py-16 sm:py-24"><article className="mx-auto max-w-xl">{t5}{t7}{t9}{t10}</article></main></div>;
    $[16] = t5;
    $[17] = t7;
    $[18] = t9;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  return t11;
}